module.exports = __webpack_public_path__ + "static/media/old-1.3d4adb08.jpeg";